

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PersonalComponent } from './pages/personal/personal.component';
import { BusinessComponent } from './pages/business/business.component';
import { DealersComponent } from './pages/dealers/dealers.component';
import { SigninComponent } from './pages/signin/signin.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { CoverageComponent } from './pages/coverage/coverage.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { BalanceComponent } from './pages/balance/balance.component';
import { UsageComponent } from './pages/usage/usage.component';
import { ManageComponent } from './pages/manage/manage.component';
import { WalletComponent } from './pages/wallet/wallet.component';
import { LoansComponent } from './pages/loans/loans.component';
import { BuydataComponent } from './pages/buydata/buydata.component';
import { DevicesComponent } from './pages/devices/devices.component';
import { AccountDetailComponent } from './pages/account-detail/account-detail.component';
import { ActivatevoiceComponent } from './pages/activatevoice/activatevoice.component';
import { CompletePaymentComponent } from './pages/complete-payment/complete-payment.component';

import { RenewplanpageComponent } from "./pages/renewplanpage/renewplanpage.component";
import { TopupPageComponent } from "./pages/topup-page/topup-page.component";
import { CyberPayVerifyComponent } from './components/cyber-pay-verify/cyber-pay-verify.component';
import { CartcheckoutComponent } from './pages/cartcheckout/cartcheckout.component';
import { RenewplanvoicepageComponent } from './pages/renewplanvoicepage/renewplanvoicepage.component';

 
import { FundwalletpageComponent } from './pages/fundwalletpage/fundwalletpage.component';
import { RequestloanpageComponent } from './pages/requestloanpage/requestloanpage.component';
import { AuthGuard } from "./security/auth.guard";
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { TransactionhistoryComponent } from './pages/transactionhistory/transactionhistory.component';
import { KycComponent } from './components/pages/kyc/kyc.component';
import { MailsubscriptionComponent } from './pages/mailsubscription/mailsubscription.component';
import {NinComponent} from './pages/nin/nin.component'

const routes: Routes = [ 
  {
    path: '',
    component: HomeComponent,
    data: { title: 'Home' }
},
{
  path: 'personal',
  component: PersonalComponent,
  data: { title: 'personal' }
},
{
  path: 'business',
  component: BusinessComponent,
  data: { title: 'business' }
},

{
  path: 'dealers',
  component: DealersComponent,
  data: { title: 'dealers' }
},
{
  path: 'signin',
  component: SigninComponent,
  data: { title: 'signin' }
},
{
  path: 'checkout',
  component: CheckoutComponent,
  data: { title: 'checkout' }
},
{
  path: 'coverage',
  component: CoverageComponent,
  data: { title: 'coverage' }
},


{
  path: 'dashboard',
  component: DashboardComponent,
  canActivate : [AuthGuard],
  data: { title: 'Dashboard' }
},

{
  path: 'balance',
  component: BalanceComponent,
  canActivate : [AuthGuard],
  data: { title: 'Balance' }
},

{
  path: 'usage',
  component: UsageComponent,
  canActivate : [AuthGuard],
  data: { title: 'Selfcare - Usage Report' }
},

{
  path: 'manage',
  component: ManageComponent,
  canActivate : [AuthGuard],
  data: { title: 'Selfcare - Manage Account' }
},


{
  path: 'datareserve',
  component: WalletComponent,
  canActivate : [AuthGuard],
  data: { title: 'Selfcare - DataReserve' }
},

{
  path: 'loans',
  component: LoansComponent,
  canActivate : [AuthGuard],
  data: { title: 'Selfcare - Loans' }
},
{
  path: 'buydata',
  component: BuydataComponent,
  data: { title: 'Selfcare - Loans' }
},


{
  path: 'devices',
  component: DevicesComponent,
  data: { title: 'Selfcare - Devices' }
},
{
  path: 'accountdetail/:id',
  component: AccountDetailComponent,
  data: { title: 'Selfcare - Account Detail' }
},

{
  path: 'activatevoice',
  component: ActivatevoiceComponent,
  data: { title: 'LTE - Activate Voice' }
},
{
  path: 'renewplan',
  component: RenewplanpageComponent,
  canActivate : [AuthGuard],
  data: { title: 'LTE - Renew plan data' }
},
{
  path: 'renewplanvoice',
  component: RenewplanvoicepageComponent,
  canActivate : [AuthGuard],
  data: { title: 'LTE - Renew voice plan' }
},

{
  path: 'completecyberpay',
  component: CompletePaymentComponent,
  data: { title: 'Complete Payment' }
},

{
  path: 'cyberPayVerify',
  component: CyberPayVerifyComponent,
  data: { title: 'Verify Payment' }
},
{
  path: 'topup',
  component: TopupPageComponent,
  canActivate : [AuthGuard],
  data: { title: 'Top up' }
},

{
  path: 'cartcheckout',
  component: CartcheckoutComponent,
  data: { title: 'Check out' }
},


{
  path: 'funddatareserve',
  component: FundwalletpageComponent,
  canActivate : [AuthGuard],
  data: { title: 'Fund DataReserve' }
},
{
  path: 'requestloan',
  component: RequestloanpageComponent,
  canActivate : [AuthGuard],
  data: { title: 'Request Loan' }
},


{
  path: 'welcome',
  component: WelcomeComponent,

  data: { title: 'Welcome' }
},
{
  path: 'unsubscribe',
  component: MailsubscriptionComponent,

  data: { title: 'Unsubscribe' }
},
{
  path: 'nin',
  component: NinComponent,
  canActivate : [AuthGuard],
  data: { title: 'nin' }
},

{
  path: 'forgotpassword',
  component: ForgotPasswordComponent,
 
  data: { title: 'forgot password' }
},


{
  path: 'transactionhistory',
  component: TransactionhistoryComponent,
 
  data: { title: 'Transaction History' }
},

{
  path: 'kyc',
  component: KycComponent,
 
  data: { title: 'KYC Information Upload' }
},





{ path: '**',
redirectTo: '/home',
pathMatch: 'full'
},






];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
